import { render, staticRenderFns } from "./SetPrivilege.vue?vue&type=template&id=029a69e7&"
import script from "./SetPrivilege.vue?vue&type=script&lang=js&"
export * from "./SetPrivilege.vue?vue&type=script&lang=js&"
import style0 from "./SetPrivilege.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!/////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports